import { BACKEND_URL } from '../config';
import * as RestService from './RestService';


const BASE_URL = BACKEND_URL + '/auth/competition-schema'

/**
 * 
 Encuentra todos los esquemas de competición de un organizador
 */
export const getAllScheme = () => {
  return RestService.get(`${BASE_URL}/list`);
}

/**
 * 
 Encuentra el esquema de competicion por id
 */
 export const getScheme = (id: any) => {
  return RestService.get(`${BASE_URL}/${id}`);
}

/**
 * 
 crea/edita esquema de competicion
 */
 export const createScheme = (form: any) => {
  return RestService.post(`${BASE_URL}/save-competition-schema`, form);
}

/**
 * 
elimina esquema de competicion
 */
 export const deleteScheme = (form: any) => {
  return RestService.post(`${BASE_URL}/delete-competition-schema`, form);
}


/********************************************************** */

/**
 * 
 crea/edita grupo de esquema de competicion
 */
 export const createSchemeGroup = (idSchema: any, form: any) => {
  return RestService.post(`${BASE_URL}/save-competition-schema-group/${idSchema}`, form);
}

/**
 * 
elimina grupo de esquema de competicion
 */
export const deleteSchemeGroup = (idSchema: any, form: any) => {
  return RestService.post(`${BASE_URL}/delete-competition-schema-group/${idSchema}`, form);
}

/********************************************* */




/**
 * 
 crea/edita grupo de esquema de competicion
 */
 export const createSchemeGroupTeam = (idCompetitionSchemaGroup: any, form: any) => {
  return RestService.post(`${BASE_URL}/save-competition-schema-group-team/${idCompetitionSchemaGroup}`, form);
}

export const deleteSchemaTeam = (team: any) => {
  return RestService.post(`${BASE_URL}/delete-team`, team);
}

/**
 * 
  Crea un grupo  

 export const createGroup = (form: any) => {
  return RestService.post(`${BASE_URL}`, form);
}
*/